import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    preview (planningObject) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}RoutePlanning/preview`, planningObject, AUTH_HEADERS())
    },
    save (planningObject) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}RoutePlanning`, planningObject, AUTH_HEADERS())
    }
}
